/**
 * Every number in this file was measured off the real corpus (spec appendix), not
 * assumed. Changing one without re-measuring is how the layout and the scheduler
 * silently drift apart from the data.
 */

export const TOTAL_PAGES = 604
export const TOTAL_AYAT = 6236
export const TOTAL_SURAHS = 114
export const TOTAL_JUZ = 30

/**
 * 9,046 physical lines: 602 pages × 15, plus pages 1 and 2 at 8 each (§3.7).
 *
 * The scheduler counts PHYSICAL lines, including the 226 that are surah headers and
 * standalone bismillahs. Excluding them would need per-page line counts that
 * meta.json does not carry and that we deliberately do not ship. It is 2.5% of the
 * mushaf, and the header is a row the reader sees on the page anyway.
 */
export const TOTAL_LINES = 9046
export const TEXT_LINES = 8820
export const CHROME_LINES = 226

// Layout (§7.6). --fit's fixed point is `widest === 0.995`; floating point never
// lands on it exactly, so without FIT_EPSILON every measurement writes a marginally
// different value and the page jitters forever (L4).
export const JUSTIFY_THRESHOLD = 0.84
export const PAGE_MARGIN = 26
export const MIN_PAGE_WIDTH = 380
export const PAGE_MAX_WIDTH = 860
export const FIT_EPSILON = 0.0005
export const MAX_MEASURE_PASSES = 8

// Font scale (§14.1)
export const FONT_SCALE_MIN = 60
export const FONT_SCALE_MAX = 170
export const FONT_SCALE_STEP = 5
export const FONT_SCALE_DEFAULT = 100

// Search (§9)
export const SEARCH_DEFAULT_LIMIT = 300
export const SEARCH_MIN_QUERY_LENGTH = 2

// SM-2 (§10.4)
export const SRS_DEFAULT_EASE = 2.5
export const SRS_MIN_EASE = 1.3
export const SRS_LAPSE_EASE_PENALTY = 0.2
export const DAY_MS = 86_400_000

// Tiers, read off the current interval (§10.4)
export const TIER_SABQ_MAX_INTERVAL = 1
export const TIER_SABQI_MAX_INTERVAL = 10

// Programmes (§11)
export const MAX_AHEAD_DAYS = 30
export const DEFAULT_MAX_CARRY_OVER = 3

// UI timing (§8)
export const NOTE_DEBOUNCE_MS = 600

// Audio (§14.1)
export const PLAYBACK_RATES = [0.5, 0.75, 0.9, 1, 1.1, 1.25, 1.5] as const
export const DEFAULT_RECITER_ID = 'husary'
export const DEFAULT_PLAYBACK_RATE = 1

// Storage (§13)
export const DB_NAME = 'mushaf'
export const DB_VERSION = 2
export const BACKUP_VERSION = 2
export const LS_LAST_PAGE = 'mushaf.lastPage'
export const LS_SETTINGS = 'mushaf.settings'
/**
 * Bumped to 2 when the hifz preferences (repeat counts, drill mode, hide-text) moved
 * into this store. A v1 payload has none of those keys, and `merge` fills them from the
 * defaults, so the bump is belt-and-braces rather than load-bearing.
 */
export const SETTINGS_VERSION = 2

/** Where the corpus is served from, relative to the site root. */
export const CORPUS_BASE = '/corpus'
